<template>
  <ckeditor
    :editor="editor"
    v-model="html_value"
    :config="editorConfig"
  ></ckeditor>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import UploadAdapterPlugin from "./Editor/InsertImage";

import "@ckeditor/ckeditor5-build-classic/build/translations/pt-br";

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: "",
  },
  data: () => ({
    editor: ClassicEditor,
    extraPlugins: [UploadAdapterPlugin],
  }),
  computed: {
    html_value: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.value ? this.value : "";
      },
    },
    editorConfig() {
      return {
        language: "pt-br",
        extraPlugins: this.extraPlugins,
        placeholder: this.placeholder,

        image: {
          toolbar: [
            "toggleImageCaption",
            "imageTextAlternative",
            "|",
            "imageStyle:block",
            "imageStyle:alignLeft",
            "imageStyle:alignRight",
          ],
        },
      };
    },
  },
};
</script>

<style lang="scss">
.ck-editor {
  .image {
    &.image-style-align-left,
    &.image-style-align-right {
      max-width: 50%;
    }
  }

  .ck-editor__editable {
    max-height: 300px;
  }
}
</style>
